
    import './styles.scoped.css';
    export default {
  "navigation": "awsui_navigation_2p2ab_o3ez8_101",
  "is-navigation-open": "awsui_is-navigation-open_2p2ab_o3ez8_129",
  "animating": "awsui_animating_2p2ab_o3ez8_133",
  "openNavigation": "awsui_openNavigation_2p2ab_o3ez8_1",
  "animated-content": "awsui_animated-content_2p2ab_o3ez8_146",
  "hide-navigation": "awsui_hide-navigation_2p2ab_o3ez8_155"
};
  